<template lang="pug">
  div.store
    van-swipe(:autoplay="autoplay")
      van-swipe-item(v-for="(image, index) in images", :key="index")
        img(:src="image")
    van-card(v-for='(item, key) in cards', :key='key' :desc="item.desc", :title="item.title", :thumb="item.thumb")
      template(#price)
        van-button(sizi='small') 储值
  //- <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  //- </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Store',
  data(){
    return{
      autoplay: 0,
      images:[
        require('../assets/swipe1.png'),
        require('../assets/swipe1.png')
      ],
      cards:[
        {
          title: '储值',
          desc: '用于游戏储值的平台货币',
          thumb: require('../assets/coins.png')
        },
        {
          title: '储值',
          desc: '用于游戏储值的平台货币',
          thumb: require('../assets/coins.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.store{
  margin: 10px;
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
}
</style>
